import { ReactNode } from "react";

export const ContainerCard = ({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={`bg-white border border-border-grey
        p-4 md:p-8 rounded-lg w-full ${className}`}
    >
      {children}
    </div>
  );
};
